import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={25} height={25} fill="none" xmlns="http://www.w3.org/2000/svg"><rect width={25} height={25} rx={12.5} fill="#9738FF" /><path d="M17.691 9.5l-5.5 6-3.5-3.818" stroke="#fff" strokeWidth={2.5} strokeLinecap="round" /></svg>;
}
export default SvgComponent;